<template>
  <div id="app">
    <home-header v-if="false"></home-header>
    <side-contact v-if="false"></side-contact>
    <main>
      <router-view/>
    </main>
    <home-footer v-if="false"></home-footer>
  </div>
</template>

<script>
import homeHeader from '@/components/home_header.vue'
import sideContact from '@/components/side_contact.vue'
import homeFooter from './components/home_footer.vue';

export default {
  name: 'app',
  // props: {
  //   msg: String
  // },
  components:{
    homeHeader,
    sideContact,
    homeFooter
},
  data(){
    return{
      
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font: 13px/1 "微软雅黑",Tahoma,Helvetica,Arial,"\5b8b\4f53",sans-serif;
  color: #2c3e50;
  background-color: #f5f5f5;
  cursor: default;
}

*{
  padding: 0;
  margin: 0;
  &::-webkit-scrollbar {
    display: none;
  }
}

.center{
  width: 1220px;
  margin: 0 auto;
}


</style>
